<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M13.2099 3.93387L13.4122 1.94412M7.77385 5.47275L6.50995 3.92274M6.70303 16.0042L5.15302 17.2681M18.3053 6.54357L19.8554 5.27967M5.17233 10.4878L3.18258 10.2855"
        :stroke="stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.8339 16.2666C30.2393 16.8373 30.1321 18.8618 28.6742 19.2809L21.318 21.3955L17.9583 28.2728C17.2924 29.6357 15.2799 29.3897 14.9619 27.9067L11.537 11.9346C11.2682 10.6811 12.5116 9.63783 13.6993 10.1202L28.8339 16.2666Z"
        :stroke="stroke"
        stroke-width="1.5"
      />
    </svg>
  </div>
</template>
<script>
import {DEFAULT_BRAND_SECONDARY_COLOR} from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
